<ng-container *ngIf="purchasedProduct?.productDetails?.premiumDeterminingFactor">
    <wuc-rack gridGap="medium">
        <ng-container *ngFor="let premiumDeterminingFactor of purchasedProduct?.productDetails?.premiumDeterminingFactor">
            <!-- Data -->
            <ins-insurance-premium-determining-factor-data
                [premiumDeterminingFactor]="premiumDeterminingFactor"
                [purchasedProduct]="purchasedProduct"
                [selected]="selectedFactorIds.includes(premiumDeterminingFactor?.factorId)"
                (selectedChange)="$event ? selectFactor(premiumDeterminingFactor?.factorId) : deselectFactor(premiumDeterminingFactor?.factorId)"
            ></ins-insurance-premium-determining-factor-data>
            <!-- Future -->
            <ins-insurance-premium-determining-factor-future
                *ngIf="premiumDeterminingFactor?.modifiableFactorFuture"
                [premiumDeterminingFactor]="premiumDeterminingFactor"
                [purchasedProduct]="purchasedProduct"
            ></ins-insurance-premium-determining-factor-future>

            <wuc-balloon
                [arrowPosition]="(isScreenSmall$ | async) ? 'topLeft' : 'topRight'"
                backgroundStyle="primary"
                padding="large"
                *ngIf="selectedFactorIds.includes(premiumDeterminingFactor?.factorId)">
                <ins-insurance-premium-determining-factor-form
                    [premiumDeterminingFactor]="premiumDeterminingFactor"
                    [purchasedProduct]="purchasedProduct"
                ></ins-insurance-premium-determining-factor-form>
            </wuc-balloon>
        </ng-container>
    </wuc-rack>
</ng-container>
